import { render, staticRenderFns } from "./OneTimeAuthModal.vue?vue&type=template&id=52cd6b1b&"
import script from "./OneTimeAuthModal.vue?vue&type=script&lang=js&"
export * from "./OneTimeAuthModal.vue?vue&type=script&lang=js&"
import style0 from "./OneTimeAuthModal.vue?vue&type=style&index=0&id=52cd6b1b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports